export const BARCODE_SCANNING = 'react-usb-barcode-scanner/scanning';
export const BARCODE_SCANNED = 'react-usb-barcode-scanner/scanned';
export const DISABLE_BARCODE_SCANNER = 'react-usb-barcode-scanner/disable';
export const ENABLE_BARCODE_SCANNER = 'react-usb-barcode-scanner/enable';
export const SET_BARCODE_HISTORY_INFO = 'react-usb-barcode-scanner/set-history-info';
